import { useRouter } from 'next/router';
import styles from './index.module.scss';
import FirstKv from './components/FirstKv';
import PageCountDown from './components/PageCountDown';
import TimeLine from './components/TimeLine';
import PageTabs from './components/PageTabs';

export default function EcoCreditsDay() {
    const { locale } = useRouter();

    return (
        <div className={styles.ecoCreditsDay}>
            <FirstKv />
            {['jp', 'kr'].includes(locale) && <PageCountDown />}
            {locale !== 'au' && <TimeLine />}
            <PageTabs />
        </div>
    );
}
